import util from '@bmp-vue/core/api/util';
const controller = 'Helper';
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  TipoPessoa: [1, 2],
  TipoProduto: [
    'RME - Refinanciamento de máquinas e equipamentos',
    'CGI - Capital de giro com garantia de imóveis',
    'CGS - Capital de giro sem garantia',
    'CGD - Capital de giro com garantia de duplicatas',
    'CGG - Conta garantida',
    'RV - Refinanciamento de veículos',
    'ADD - Antecipação de duplicatas',
  ],
  TipoDocumentoPessoa: [
    { tipoDocumento: 'CPF', obrigatorio: true },
    { tipoDocumento: 'RG', obrigatorio: false },
    { tipoDocumento: 'CNH', obrigatorio: false },
  ],
  TipoDocumentoProposta: [
    { tipoDocumento: 'Contrato social', obrigatorio: false },
    { tipoDocumento: 'Cartão CNPJ', obrigatorio: true },
    { tipoDocumento: 'Inscrição municipal', obrigatorio: false },
  ],
  TipoPapel: [
    { value: 1, name: 'Agente de garantia', description: 'Instituição ou pessoa jurídica que administra e/ou registra a(s) garantia(s) de uma operação.' },
    { value: 2, name: 'Interveniente anuente', description: 'Pessoa física ou jurídica que manifesta formalmente sua concordância com os termos da operação, sem necessariamente assumir responsabilidade direta pelo pagamento.' },
    { value: 3, name: 'Avalista', description: 'Pessoa física ou jurídica que garante o pagamento da dívida caso o emitente não cumpra com a obrigação. Solidário ao devedor.' },
    { value: 4, name: 'Cônjuge anuente', description: 'Cônjuge do devedor que dá ciência e concordância com a operação, especialmente relevante quando há alienação de bens comuns do casal.' },
    { value: 5, name: 'Credor', description: 'Instituição financeira ou parceiro cessionário que concede o crédito ao emitente.' },
    { value: 6, name: 'Devedor', description: 'Pessoa física ou jurídica responsável pelo pagamento da dívida assumida na CCB ou Nota Comercial. É o principal obrigado no contrato.' },
    { value: 7, name: 'Devedor solidário', description: 'Pessoa física ou jurídica que assume, junto ao devedor principal, a obrigação de pagamento, respondendo integralmente pela dívida caso o devedor não cumpra.' },
    { value: 8, name: 'Emissor (a)', description: 'No contexto de Nota Comercial, é a empresa que emite o título com o objetivo de captar recursos junto ao mercado.' },
    { value: 9, name: 'Emitente', description: 'No contexto da CCB, é a pessoa física ou jurídica que contrai o crédito e assume a obrigação de pagamento.' },
    { value: 10, name: 'Escriturador', description: 'Instituição autorizada responsável pelo registro, controle e escrituração eletrônica dos títulos e valores mobiliários da operação.' },
    { value: 11, name: 'Fiduciante', description: 'Parte que transfere a propriedade de um bem, de sua titularidade, como garantia às obrigações garantidas devidas ao fiduciário, mantendo a posse indireta enquanto estiver adimplente.' },
    { value: 12, name: 'Fiduciário/ Credor', description: 'Instituição financeira ou pessoa que recebe o bem em garantia fiduciária, tendo direito sobre ele em caso de inadimplemento.' },
    { value: 13, name: 'Fiel depositário', description: 'Pessoa física nomeada para custodiar bens oferecidos em garantia, com responsabilidade legal sobre sua guarda e integridade.' },
    { value: 14, name: 'Procurador', description: 'Pessoa física autorizada, via procuração, a representar outra parte na assinatura e condução da operação de crédito.' },
    { value: 15, name: 'Representante legal', description: 'Pessoa física autorizada, via atos societários, a assinar o documento em nome de uma empresa (se emitente ou avalista for pessoa jurídica).' },
    { value: 16, name: 'Subscritor/ Titular da nota comercial', description: 'Investidor que adquire a Nota Comercial, assumindo o papel de credor em relação ao emissor.' },
    { value: 17, name: 'Terceiro garantidor', description: 'Pessoa física ou jurídica, diversa do emitente, emissor ou avalista da obrigação principal, que oferece bem ou direito de sua titularidade em garantia ao cumprimento da obrigação.' }
  ],
  TipoDesembolso: ['Emitente', 'Portal', 'Correspondente', 'Outros'],
  Produtos: [
    {
      id: 1,
      habilitado: true,
      tipoProduto: 'RME - Refinanciamento de máquinas e equipamentos',
      tipoPessoa: [1, 2],
      situacaoProposta: 1,
      vlrTAC: 300.00,
      percTAC: 2.5,
      isentarIOF: false,
      vencPrimeiraParcela: [{ quantidade: '30', tipoTempo: 'Dias' }],
      desembolso: ['Correspondente'],
      participantes: [
        { tipo: 'Emitente', pessoa: [1, 2] }
      ],
      tipoAssinatura: [{ text: 'Assinatura eletrônica', value: 'E', CCB: 1 }, { text: 'Certificação digital', value: 'D', CCB: 1 }],
      registros: [
        { tipo: 'Bens móveis', itens: [{ registro: 'Veículo automotor', taxa: 100 }, { registro: 'Máquinas', taxa: 50 }] }
      ],
      garantias: [
        { tipo: 'Bens móveis', itens: [{ garantia: 'Máquinas e equipamentos', taxa: 0 }] }
      ],
      documentosPessoa: [
        { tipoDocumento: 'CPF', obrigatorio: true },
        { tipoDocumento: 'RG', obrigatorio: false },
      ],
      documentosProposta: [
        { tipoDocumento: 'Contrato social', obrigatorio: true }
      ]
    },
    {
      id: 1,
      habilitado: true,
      tipoProduto: 'CGI - Capital de giro com garantia de imóveis',
      tipoPessoa: [1, 2],
      situacaoProposta: 2,
      vlrTAC: 500.00,
      percTAC: 3.0,
      isentarIOF: true,
      vencPrimeiraParcela: [{ quantidade: '30', tipoTempo: 'Dias' }],
      desembolso: ['Correspondente'],
      participantes: [
        { tipo: 'Emitente', pessoa: [1, 2] }
      ],
      tipoAssinatura: [{ text: 'Assinatura eletrônica', value: 'E', CCB: 1 }, { text: 'Certificação digital', value: 'D', CCB: 1 }],
      registros: [
        { tipo: 'Bens móveis', itens: [{ registro: 'Veículo automotor', taxa: 0 }, { registro: 'Máquinas', taxa: 0 }, { registro: 'Aeronave', taxa: 0 }, { registro: 'Joia, quadro', taxa: 0 }] }
      ],
      garantias: [
        { tipo: 'Bens móveis', itens: [{ garantia: 'Máquinas e equipamentos', taxa: 0 }] }
      ],
      documentosPessoa: [
        { tipoDocumento: 'RG', obrigatorio: false }
      ],
      documentosProposta: [
        { tipoDocumento: 'Cartão CNPJ', obrigatorio: true }
      ]
    },
    {
      id: 2,
      habilitado: true,
      tipoProduto: 'CGD - Capital de giro com garantia de duplicatas',
      tipoPessoa: [1, 2],
      situacaoProposta: 2,
      vlrTAC: 250.00,
      percTAC: 1.8,
      isentarIOF: false,
      vencPrimeiraParcela: [{ quantidade: '30', tipoTempo: 'Dias' }],
      desembolso: ['Correspondente'],
      participantes: [
        { tipo: 'Emitente', pessoa: [1, 2] }
      ],
      tipoAssinatura: [{ text: 'Assinatura eletrônica', value: 'E', CCB: 1 }, { text: 'Certificação digital', value: 'D', CCB: 1 }],
      registros: [
        { tipo: 'Bens móveis', itens: [{ registro: 'Veículo automotor', taxa: 0 }, { registro: 'Máquinas', taxa: 0 }, { registro: 'Aeronave', taxa: 0 }, { registro: 'Joia, quadro', taxa: 0 }] }
      ],
      garantias: [
        { tipo: 'Bens móveis', itens: [{ garantia: 'Máquinas e equipamentos', taxa: 0 }] }
      ],
      documentosPessoa: [
        { tipoDocumento: 'CNH', obrigatorio: false }
      ],
      documentosProposta: [
        { tipoDocumento: 'Cartão CNPJ', obrigatorio: true },
      ]
    },
    {
      id: 3,
      habilitado: true,
      tipoProduto: 'CGG - Conta garantida',
      tipoPessoa: [1, 2],
      situacaoProposta: 1,
      vlrTAC: 400.00,
      percTAC: 2.0,
      isentarIOF: true,
      vencPrimeiraParcela: [{ quantidade: '30', tipoTempo: 'Dias' }],
      desembolso: ['Correspondente'],
      participantes: [
        { tipo: 'Emitente', pessoa: [1, 2] }
      ],
      tipoAssinatura: [{ text: 'Assinatura eletrônica', value: 'E', CCB: 1 }, { text: 'Certificação digital', value: 'D', CCB: 1 }],
      registros: [
        { tipo: 'Bens móveis', itens: [{ registro: 'Veículo automotor', taxa: 0 }, { registro: 'Máquinas', taxa: 0 }, { registro: 'Aeronave', taxa: 0 }, { registro: 'Joia, quadro', taxa: 0 }] }
      ],
      garantias: [
        { tipo: 'Bens móveis', itens: [{ garantia: 'Máquinas e equipamentos', taxa: 0 }] }
      ],
      documentosPessoa: [
        { tipoDocumento: 'CNH', obrigatorio: false }
      ],
      documentosProposta: [
        { tipoDocumento: 'Contrato Social', obrigatorio: false }
      ]
    },
    {
      id: 4,
      habilitado: true,
      tipoProduto: 'RV - Refinanciamento de veículos',
      tipoPessoa: [1, 2],
      situacaoProposta: 1,
      vlrTAC: 150.00,
      percTAC: 1.0,
      isentarIOF: false,
      vencPrimeiraParcela: [{ quantidade: '30', tipoTempo: 'Dias' }],
      desembolso: ['Correspondente'],
      participantes: [
        { tipo: 'Emitente', pessoa: [1, 2] }
      ],
      tipoAssinatura: [{ text: 'Assinatura eletrônica', value: 'E', CCB: 1 }, { text: 'Certificação digital', value: 'D', CCB: 1 }],
      registros: [
        { tipo: 'Bens móveis', itens: [{ registro: 'Veículo automotor', taxa: 0 }, { registro: 'Máquinas', taxa: 0 }, { registro: 'Aeronave', taxa: 0 }, { registro: 'Joia, quadro', taxa: 0 }] }
      ],
      garantias: [
        { tipo: 'Bens móveis', itens: [{ garantia: 'Máquinas e equipamentos', taxa: 0 }] }
      ],
      documentosPessoa: [
        { tipoDocumento: 'CPF', obrigatorio: true },
      ],
      documentosProposta: [
        { tipoDocumento: 'Cartão CNPJ', obrigatorio: true }
      ]
    },
    {
      id: 5,
      habilitado: true,
      tipoProduto: 'ADD - Antecipação de duplicatas',
      tipoPessoa: [1, 2],
      situacaoProposta: 2,
      vlrTAC: 120.00,
      percTAC: 1.2,
      isentarIOF: true,
      vencPrimeiraParcela: [{ quantidade: '30', tipoTempo: 'Dias' }],
      desembolso: ['Correspondente'],
      participantes: [
        { tipo: 'Emitente', pessoa: [1, 2] }
      ],
      tipoAssinatura: [{ text: 'Assinatura eletrônica', value: 'E', CCB: 1 }, { text: 'Certificação digital', value: 'D', CCB: 1 }],
      registros: [
        { tipo: 'Bens móveis', itens: [{ registro: 'Veículo automotor', taxa: 0 }, { registro: 'Máquinas', taxa: 0 }, { registro: 'Aeronave', taxa: 0 }, { registro: 'Joia, quadro', taxa: 0 }] }
      ],
      garantias: [
        { tipo: 'Bens móveis', itens: [{ garantia: 'Máquinas e equipamentos', taxa: 0 }] }, { tipo: 'Bens Imóveis', itens: [{ garantia: 'Garagem', taxa: 0 }] }
      ],
      documentosPessoa: [
        { tipoDocumento: 'CPF', obrigatorio: true },
      ],
      documentosProposta: [
        { tipoDocumento: 'Cartão CNPJ', obrigatorio: true },
      ]
    }
  ],
  Registros: [{ tipo: 'Bens móveis', itens: [{ registro: 'Veículo automotor', taxa: 0 }, { registro: 'Máquinas', taxa: 0 }, { registro: 'Aeronave', taxa: 0 }, { registro: 'Joia, quadro', taxa: 0 }] }],
  Garantias: [
    { tipo: 'Bens móveis', itens: [{ garantia: 'Veículo automotor terrestre, aquático, moto, etc', taxa: 0, gravame: false }, { garantia: 'Joia, quadro, objeto de arte', taxa: 0 }, { garantia: 'Máquinas e equipamentos', taxa: 0 }, { garantia: 'Bem relacionado com atividade autônoma', taxa: 0 }, { garantia: 'Aeronave', taxa: 0 }, { garantia: 'Embarcações', taxa: 0 }] },
    { tipo: 'Bens imóveis', itens: [{ garantia: 'Prédio residencial', taxa: 0 }, { garantia: 'Garagem', taxa: 0 }, { garantia: 'Terreno', taxa: 0 }, { garantia: 'Vaga', taxa: 0 }] },
    { tipo: 'Bens financeiros', itens: [{ garantia: 'AF cotas de fundos de investimentos', taxa: 0 }, { garantia: 'AF ações bens financeiros', taxa: 0 }, { garantia: 'AF recebíveis de carteira', taxa: 0 }, { garantia: 'AF cotas de SPE', taxa: 0 }] }
  ],
  getChipProps (situacao) {
    switch (situacao) {
      case 1:
        return { class: 'chip-aprovada', icon: 'ph ph-check-circle', text: 'Aprovada' }
      case 2:
        return { class: 'chip-analise', icon: 'ph ph-clock', text: 'Em análise' }
    }
  }
});
